import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ChargerLocationForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, submitChange } = useFormModel<ChangeNames.CHARGER_LOCATION>();

    const value = values.chargerLocations.value;
    const selection = Object.keys(value)
        .filter(key => value[key as keyof typeof value])
        .sort()
        .join("#");

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Standort der Ladeeinrichtung
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            const newValues = setValues(values => {
                                values.chargerLocations.value = {
                                    privateParkingGround: v.indexOf("privateParkingGround") >= 0,
                                    publicParkingGround: v.indexOf("publicParkingGround") >= 0,
                                };
                            });
                            submitChange(newValues);
                        }}
                    >
                        <FormControlLabel
                            value="privateParkingGround"
                            control={<Radio />}
                            label="Auf privatem Grund"
                            text="Beispiel: Garage, Stellplatz, Tiefgarage, Firmenparkplatz auf eigenem Gelände"
                            error={values.chargerLocations.error !== null}
                        />
                        <FormControlLabel
                            value="publicParkingGround"
                            control={<Radio />}
                            label="Auf öffentlich zugänglichem Grund"
                            text="Beispiel: Parkhaus, Einkaufszentrum, öffentliche Parkplätze, Kundenparkplätze"
                            error={values.chargerLocations.error !== null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
